const issuePaths = {
  issues: 'issues'
}

export default issuePaths;